import { InjectionToken } from '@angular/core';
import { Notification } from 'src/app/models/domain';
import { PagedCollection } from 'src/app/state';

export const HISTORY_PAGINATOR = new InjectionToken('HISTORY_PAGINATOR', {
  factory: () => new PagedCollection<Notification>(),
  providedIn: 'root',
});
